import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import { useState } from 'react';
import { RouteResource, TurnResource } from '~/generated';
import { Link } from '@tanstack/react-router';

export type ExpandedTurnResource = Omit<TurnResource, 'route'> & {
  route: RouteResource;
};
type TurnMenuProps = {
  selectedTurn: ExpandedTurnResource;
  turns: ExpandedTurnResource[];
  shiftId: number;
};

const TurnMenu = (props: TurnMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Button
        id="turn-selection-buttion"
        aria-controls={open ? 'turn-selection-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        color="inherit"
        endIcon={<ArrowDropDown />}
      >
        {(props.selectedTurn.route as RouteResource).name}
      </Button>
      <Menu
        id="turn-selection-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          list: {
            'aria-labelledby': 'turn-selection-buttion',
          },
        }}
      >
        {props.turns.map((turn) => (
          <MenuItem
            key={turn.id}
            onClick={handleClose}
            component={Link}
            to={`/weekplan/assignment/${props.shiftId}/${turn.id}`}
          >
            {(turn.route as RouteResource).name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default TurnMenu;
